import React, { useEffect } from 'react';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import QuickResults from './QuickResults';

function QuickResultsContainer(props) {
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
  }, []);
  return <QuickResults {...props} />;
}

export default QuickResultsContainer;
